import { render, staticRenderFns } from "./Asignatura.vue?vue&type=template&id=bb60165e"
import script from "./Asignatura.vue?vue&type=script&lang=js"
export * from "./Asignatura.vue?vue&type=script&lang=js"
import style0 from "./Asignatura.vue?vue&type=style&index=0&id=bb60165e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports